export default function About() {
  const features = [
    {
      icon: 'ri-building-line',
      title: 'Multi-Service Expertise',
      description: 'Comprehensive solutions across business, property, automotive, and asset management verticals.'
    },
    {
      icon: 'ri-organization-chart',
      title: 'Structured Operations',
      description: 'Organized systems and processes designed for consistency, reliability, and scalability.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Licensed & Compliant',
      description: 'Professional standards maintained across all service lines and business operations.'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Scalable Solutions',
      description: 'Services built to grow with your business and adapt to evolving operational needs.'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white relative">
      <div className="absolute top-0 left-0 right-0 h-px bg-grey-200"></div>
      
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-navy-900 mb-6">
            About Iron Asset Management
          </h2>
          <div className="max-w-4xl mx-auto space-y-4">
            <p className="text-lg text-grey-700 leading-relaxed">
              Iron Asset Management LLC is a multi-service company providing structured business and asset-based solutions across multiple industries.
            </p>
            <p className="text-lg text-grey-700 leading-relaxed">
              We specialize in supporting businesses, properties, vehicles, and operational assets with a focus on reliability, organization, and long-term value.
            </p>
            <p className="text-xl font-semibold text-navy-800 mt-6">
              Built to serve. Built to scale.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-grey-50 p-8 rounded-lg border border-grey-200 hover:border-navy-400 transition-all hover:shadow-lg group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-navy-700 rounded-lg mb-6 group-hover:bg-navy-600 transition-colors">
                <i className={`${feature.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-grey-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
